import React, { useState } from "react";
import Footer from "../../components/footer/Footer";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { Stack } from "@mui/material";
import { RxAvatar } from "react-icons/rx";
import { FaPenAlt } from "react-icons/fa";
import { IoMdQrScanner } from "react-icons/io";
import { MdOutlineTranslate } from "react-icons/md";
import { BiNotepad } from "react-icons/bi";
import { FaGears } from "react-icons/fa6";
import { IoIosTimer } from "react-icons/io";
import Button from "@mui/material/Button";
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { toast } from "react-toastify";

function Profile() {
    const auth = getAuth();

    const [formData] = useState({
        name: auth.currentUser.displayName,
        email: auth.currentUser.email,
    });

    function logout() {
        auth.signOut()
            .then(() => {
                toast.success("LoggedOut successfully");
                navigate("/");
            })
            .catch((err) => {
                toast.error("There was an error loggin Out");
            });
    }
    const navigate = useNavigate();
    return (
        <>
            <div className="UserProfile">
                <div className="UserDetailsDiv">
                    <Box
                        className="UserDetailsWrapper"
                        // sx={{
                        //     marginTop: 8,
                        //     display: "flex",
                        //     flexDirection: "column",
                        //     alignItems: "center",
                        //     justifyContent: "center",
                        // }}
                    >
                        <div className="UserContainer">
                            <div className="profileWrapper">
                                <Avatar
                                    sx={{
                                        m: 1,
                                        bgcolor: "secondary.main",
                                        width: 35,
                                        height: 35,
                                    }}
                                >
                                    <RxAvatar />
                                </Avatar>
                                <div>
                                    <h3 className="detailsText">
                                        {formData.name}
                                    </h3>
                                </div>
                                {/* <Grid item xs={12} sm={6}>
                                    <h3 className="detailsText">
                                        {formData.email}
                                    </h3>
                                </Grid> */}
                            </div>
                            <Button
                                variant="contained"
                                className="ButtonHome"
                                onClick={logout}
                            >
                                Logout
                            </Button>
                        </div>
                    </Box>
                </div>
                <div className="FeaturesContainer">
                    <div className="CardContainer">
                        <Stack direction="row" spacing={3} mb={3}>
                            <Box className="CardBox">
                                <Stack direction="row" spacing={2}>
                                    <div className="CardIconContainer">
                                        <IoMdQrScanner
                                            width={15}
                                            height={15}
                                            className="CardIcon"
                                        />
                                    </div>
                                    <Stack className="CardTextContainer">
                                        <h3>AI detection</h3>
                                        <p>
                                            Check your document for AI-written
                                            content
                                        </p>
                                        <Button
                                            variant="contained"
                                            className="CardButton"
                                            onClick={() => {
                                                navigate("/aichecker");
                                            }}
                                        >
                                            Check Now
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Box>
                            <Box className="CardBox">
                                <Stack direction="row" spacing={2}>
                                    <div className="CardIconContainer">
                                        <MdOutlineTranslate
                                            width={15}
                                            height={15}
                                            className="CardIcon"
                                        />
                                    </div>
                                    <Stack className="CardTextContainer">
                                        <h3>Translator</h3>
                                        <p>Translate documents accurately!</p>
                                        <Button
                                            variant="contained"
                                            className="CardButton"
                                            onClick={() => {
                                                navigate("/");
                                            }}
                                        >
                                            Translate Now
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Stack>
                        <Stack direction="row" spacing={3} mb={3}>
                            <Box className="CardBox">
                                <Stack direction="row" spacing={2}>
                                    <div className="CardIconContainer">
                                        <FaPenAlt
                                            width={12}
                                            height={12}
                                            className="CardIcon"
                                        />
                                    </div>
                                    <Stack className="CardTextContainer">
                                        <h3>Citation Generator</h3>
                                        <p>Create Accurate Citations </p>
                                        <Button
                                            variant="contained"
                                            className="CardButton"
                                            onClick={() => {
                                                navigate("/");
                                            }}
                                        >
                                            Generate Now
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Box>
                            <Box className="CardBox">
                                <Stack direction="row" spacing={2}>
                                    <div className="CardIconContainer">
                                        <BiNotepad
                                            width={15}
                                            height={15}
                                            className="CardIcon"
                                        />
                                    </div>
                                    <Stack className="CardTextContainer">
                                        <h3>Summarizer</h3>
                                        <p>
                                            Summarizes large paragraph
                                            efficiently!
                                        </p>
                                        <Button
                                            variant="contained"
                                            className="CardButton"
                                            onClick={() => {
                                                navigate("/summarize");
                                            }}
                                        >
                                            Summarize Now
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Stack>
                        <Stack direction="row" spacing={3}>
                            <Box className="CardBox">
                                <Stack direction="row" spacing={2}>
                                    <div className="CardIconContainer">
                                        <FaGears
                                            width={15}
                                            height={15}
                                            className="CardIcon"
                                        />
                                    </div>
                                    <Stack className="CardTextContainer">
                                        <h3>Optimize</h3>
                                        <p>
                                            Optimize prompts for better outputs.
                                        </p>
                                        <Button
                                            variant="contained"
                                            className="CardButton"
                                            onClick={() => {
                                                navigate("/optimize");
                                            }}
                                        >
                                            Optimize Now
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Box>
                            <Box className="CardBox">
                                <Stack direction="row" spacing={2}>
                                    <div className="CardIconContainer">
                                        <IoIosTimer
                                            width={15}
                                            height={15}
                                            className="CardIcon"
                                        />
                                    </div>
                                    <Stack className="CardTextContainer">
                                        <h3>More coming soon...</h3>
                                        <p>Stay tuned for more tools</p>
                                        <Button
                                            variant="contained"
                                            className="CardButton"
                                            disabled
                                        >
                                            Upcoming ...
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Stack>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Profile;
